import type { RoleCode } from '@/consts/roles';
import { env } from '@/env/env';

import type { User } from './schema';

export const hasAnyRole = (user: User | null | undefined, roles: RoleCode[]): boolean => {
  if (env.VITE_BYPASS_PERMISSIONS === 'true') return true;
  if (!user?.Roles) return false;
  return user.Roles.some((role) => roles.includes(role.Id as RoleCode));
};
